import { defineMessages } from 'react-intl';

const translations = {
  byAuthor: {
    id: 'appsList.app.byAuthor',
    defaultMessage: 'By {author}',
    description: 'Label of the author of an app in the apps list',
  },
  actions: {
    add: {
      id: 'appsList.app.actions.add',
      defaultMessage: 'Add app',
      description: 'Label of the add action of an app in the apps list',
    },
  },
};

export default defineMessages(translations);
